export class MessagingService {
    public static postMessage(messageObj: any): void {
        window.postMessage(
            messageObj,
            `${window.location.protocol}//${window.location.host}`)
    }
}